import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { makeListQuery } from '../../common/list-query/list-query';
import { ViolationActionSchema } from '../violation-action/violation-action';
import { ViolationSeveritySchema } from '../violation-severity/violation-severity';

/**
 * The whitelisted filters of the violation-type catalogue (N7).
 *
 * `isActive` is the one that matters day to day — deactivated types are kept for
 * ever so old cases stay readable, so without it the catalogue grows a tail of
 * rows nobody is configuring any more. It is a strict `'true'|'false'` transform
 * and **never** `z.coerce.boolean()`, which would read `'false'` as `true` (N7).
 *
 * `search` matches the key, not the translated name: the key is the stable
 * identity and the one thing a staff member can quote from a case they are
 * looking at.
 */
export const ViolationTypesListQuerySchema = makeListQuery({
  isActive: BooleanParamSchema.optional(),
  severity: ViolationSeveritySchema.optional(),
  action: ViolationActionSchema.optional(),
  search: z.string().trim().min(1).max(64).optional(),
});

export type ViolationTypesListQuery = z.infer<typeof ViolationTypesListQuerySchema>;
